import React from 'react';

export default function ItemYORP(props) {

    const { title, sel, onClick, icon } = props;
   
    if (sel) {
        return (
            
            <div style={ { 
                // marginBlock: 6, 
                borderRadius: 8, 
                cursor: 'pointer',
                borderStyle: 'solid',
                animation: sel === title ? 'borderYORP 8s linear infinite' : 'none',
                borderColor: 'var(--ltg)',
                backgroundColor: 'var(--drg)', 
                }}>
                <div
                    style={{
                        padding: 10,
                        textAlign: 'center'
                    }}
                    onClick={onClick}
                >
                    <p style={ {
                            borderRadius: 3,
                            animation: sel === title ? 'colorYORP 8s linear infinite' : 'none',
                            color: "var(--wht)",
                        }}>{title}</p>
                </div>
            </div>
        );
    } else {
        return (
            <div style={{ 
                borderRadius: 5, 
                padding: 2, 
                borderWidth: '2px',
                borderStyle: sel === title ? 'solid' : 'none',
                animation: sel === title ? 'borderYORP 8s linear infinite' : 'none',
                backgroundColor: "var(--drg)",
                justifyContent: 'center', 
                display: 'flex'
            }}>
                <div
                    onClick={onClick}
                >
                    <p
                        style={{
                            padding: 10,
                            borderRadius: 3,
                            animation: 'colorYORP 8s linear infinite',
                        }}>{title}</p>
                </div>
            </div>
        );
    }
}
